import './unauthorized.scss';
import { Card, Row, Col, Typography, Button } from 'antd';
import notFoundImg from '../../../assets/notFound.png';
import { LogoutOutlined } from '@ant-design/icons';
import authService from '../../../configs/auth/authServices';

const { Paragraph, Title } = Typography;

const UnauthorizedPage = () => {
    return (
        <div className="notAuth">
            <Card>
                <Row gutter={{ lg: 24 }}>
                    <Col className="gutter-row textNF" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <Title level={3}>NON AUTORIZZATO</Title>
                        <Paragraph>
                            Non sei autorizzato ad accedere alla pagina che stai cercando.
                        </Paragraph>
                        <Button onClick={() => authService.logout()} type="dashed" icon={<LogoutOutlined />}>Sign Out</Button>
                    </Col>
                    <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                        <img src={notFoundImg} alt="Page not found" />
                    </Col>
                </Row>
            </Card>
        </div>
    );
}
export default UnauthorizedPage;